module.exports = __webpack_public_path__ + "static/media/volar-regional.755ef04b.png";